import React from 'react';
import { faFlag,faFutbol,faMapMarked,faMars } from '@fortawesome/free-solid-svg-icons'
import {faFacebook, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import male from '../Images/male.png'
import female from '../Images/female.png'
import './Details.css'

const Details = (props) => {
    const {strBanner, intFormedYear, strCountry, strSport, strLeagueAlternate, strGender, strDescriptionEN} = props.detail;
    let gender = props.detail.strGender;
    return (
        <div>
            <div className="banner">
                <img src={strBanner} alt=""/>
            </div>
            <div className="detail-area">
                <div className="detail">
                <h2>{strLeagueAlternate}</h2>
                <p><FontAwesomeIcon icon={faMapMarked}/> Founded: {intFormedYear}</p>
                <p><FontAwesomeIcon icon={faFlag}/> Country: {strCountry}</p>
                <p><FontAwesomeIcon icon={faFutbol}/> Sport Type: {strSport}</p>
                <p><FontAwesomeIcon icon={faMars}/> Gender: {strGender}</p>
            </div>
            <div className="player-img">
                {gender == strGender ? <img src={male} alt=""/> : <img src={female} alt=""/>}
            </div>
            </div>
            <h5>{strDescriptionEN}</h5>
            <div>
                <footer>
                    <a href=""><FontAwesomeIcon icon={faTwitter}/></a> 
                    <a href=""><FontAwesomeIcon icon={faFacebook}/></a> 
                    <a href=""><FontAwesomeIcon icon={faYoutube}/></a> 
                </footer>
            </div>
        </div>
    );
};

export default Details;